import * as tslib_1 from "tslib";
import service from '@/api/request';
import { Component, Vue, Prop, Provide, Watch } from 'vue-property-decorator';
import ROUTER_LINK_PARAMS from './config';
// 初始化默认链接
const initRouterLink = 'zuowenzhitiao://discover/subjectDetail';
let ClientRouter = class ClientRouter extends Vue {
    constructor() {
        super(...arguments);
        // 配置的客户端路由
        this.fullLink = '';
        this.showHrefByText = false;
        this.routeType = 1; // 初始化的routeType
        this.routerList = [];
        this.dialogVisible = false;
        // 选中路由
        this.routerLink = initRouterLink;
        this.isModelEssay = 0;
        this.validateText = ''; // 校验请求的提示文字
        this.isParamsPass = true; // 参数校验是否通过
    }
    get fullLinks() {
        return this.fullLink;
    }
    handleRouterUrlChange() {
        this.getInitUrl();
    }
    beforeMount() {
        this.routerList = JSON.parse(JSON.stringify(ROUTER_LINK_PARAMS));
        this.getInitUrl();
    }
    // 提供对外函数，获取最终结果
    getCurrentSelect() {
        return new Promise((resolve, reject) => {
            let routerList = JSON.parse(JSON.stringify(this.routerList));
            let routerLink = this.routerLink;
            let { params } = routerList[routerLink];
            if (params) {
                for (let i in params) {
                    if (!params[i].val && !params[i].ignore) {
                        reject(`请输入${params[i].text}`);
                    }
                    else if (i === 'url') {
                        params[i].val = encodeURIComponent(params[i].val);
                    }
                }
            }
            routerList[routerLink].isModelEssay = this.isModelEssay || 0;
            resolve({
                routerLink,
                router: routerList[routerLink],
                isParamsPass: this.isParamsPass,
            });
        });
    }
    // 获取初始化链接显示
    getInitUrl() {
        let { fullLinks, routerList, routeType } = this;
        // 先decode，考虑url作为参数的情况
        fullLinks = fullLinks && decodeURIComponent(fullLinks);
        if (fullLinks) {
            // 获取第一个？下标
            let firstQuestionMark = fullLinks.indexOf('?');
            let href = '';
            let params = '';
            let router = {};
            let paramList = [];
            if (firstQuestionMark === -1) {
                href = fullLinks;
                params = '';
            }
            else {
                href = fullLinks.substring(0, firstQuestionMark);
                params = fullLinks.substring(firstQuestionMark + 1);
            }
            if (routerList[href]) {
                this.routerLink = href;
                router = routerList[href];
                // 链接url特殊处理
                if (href === 'zuowenzhitiao://main/webView' ||
                    href === 'zuowenzhitiao://main/xiaoetongWebView') {
                    router.params.url.val = params.split('url=')[1];
                }
                else if (router && router.params) {
                    paramList = params.split('&');
                    paramList.forEach(item => {
                        let [key, val] = item.split('=');
                        for (let k in router.params) {
                            if (k === key) {
                                router.params[k].val =
                                    val === 'null' || val === '' ? null : val;
                            }
                        }
                    });
                }
            }
        }
        else if (routeType) {
            Object.keys(routerList).forEach(key => {
                if (routerList[key].routeType === routeType) {
                    this.routerLink = key;
                }
            });
        }
    }
    searchTarget(val, routeType, isCheck) {
        if (routeType && routeType != 19 && routeType != 30) {
            //非19类型（网址）则检查输入是否正整数
            let flag = new RegExp('^[1-9]([0-9])*$').test(val.toString());
            if (!flag) {
                this.routerList[this.routerLink].params.tabIndex.val = '';
                return this.$alert('ID参数只能输入正整数');
            }
            if (routeType === 13) {
                // console.log('1111', this.routerList[this.routerLink].params.tabIndex.val)
                // console.log(val)
                if (val != 1 && val != 2) {
                    this.routerList[this.routerLink].params.tabIndex.val = '';
                    return;
                }
            }
        }
        if (this.timer)
            clearTimeout(this.timer);
        if (isCheck)
            this.isParamsPass = false;
        this.timer = setTimeout(() => {
            validate.call(this);
        }, 1000);
        const validate = () => {
            //console.log("routeType:"+routeType+",targetId:"+val)
            // if (routeType && routeType != 19 && routeType != 30) {
            // 	//非19类型（网址）则检查输入是否正整数
            // 	let flag = new RegExp("^[1-9]([0-9])*$").test(val.toString());
            // 	if (!flag) {
            // 		return this.$alert('ID参数只能输入正整数');
            // 	}
            // 	if (routeType === 13) {
            // 		// console.log('1111', this.routerList[this.routerLink].params.tabIndex.val)
            // 		// console.log(val)
            // 		if (val != 1 && val != 2) {
            // 			this.routerList[this.routerLink].params.tabIndex.val = ''
            // 			return;
            // 		}
            // 	}
            // }
            if (val && isCheck) {
                service.getByParams('/courseAdmin/pushNotice/routeName', {
                    targetId: val,
                    type: routeType,
                }).then(res => {
                    const { data } = res.data;
                    if (data && data.name) {
                        this.validateText = data.name;
                        this.isModelEssay = data.isModelEssay || 0;
                        this.isParamsPass = true;
                    }
                    else {
                        switch (routeType) {
                            case 4:
                            case 5:
                            case 6:
                                this.validateText = '纸条不存在或非所选类型纸条；';
                                break;
                            case 1:
                                this.validateText = '专题不存在或专题已下线';
                                break;
                            case 2:
                                this.validateText = '纸条夹不存在或纸条夹已下线；';
                                break;
                            case 8:
                                this.validateText = '用户不存在';
                                break;
                            case 10:
                                this.validateText = '作品不存在或作品已下线；';
                                break;
                            case 17:
                                this.validateText = '圈子不存在';
                                break;
                        }
                        this.isParamsPass = false;
                    }
                })
                    .catch(err => {
                    this.$message({
                        message: '网络异常',
                        type: 'error',
                    });
                    this.isParamsPass = false;
                });
            }
        };
    }
    selectHandle() {
        this.isParamsPass = true;
    }
    beforeDestroy() {
        clearTimeout(this.timer);
    }
};
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], ClientRouter.prototype, "fullLink", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], ClientRouter.prototype, "showHrefByText", void 0);
tslib_1.__decorate([
    Prop({ type: Number, default: 1 })
], ClientRouter.prototype, "routeType", void 0);
tslib_1.__decorate([
    Provide()
], ClientRouter.prototype, "validateText", void 0);
tslib_1.__decorate([
    Watch('fullLink')
], ClientRouter.prototype, "handleRouterUrlChange", null);
ClientRouter = tslib_1.__decorate([
    Component
], ClientRouter);
export default ClientRouter;
